export default __webpack_public_path__ + "imgs/e3d127c9e6a7da9f3087e58c593af78f.jpg";